/**
* @file 整站的常量
* @author Ice(chenzhouji@baidu.com)
*/

export const SITE_HEADER_HEIGHT = 60;

// gatsby-config里也有这个map，改的时候一起改
export const headerHeightMap = {
    'acg-portal': 96,
    'acg-portal-new': 96,
    'acg-portal-en': 60,
    'default': SITE_HEADER_HEIGHT
}
